'use client';
import { useGetCategories } from '@/backend/casino/get-categories';
import { getIcon } from '@/Icons';
import React, { useEffect } from 'react';

const SetCasinoCategories = () => {
	const { getCategories } = useGetCategories();

	useEffect(() => {
		const getData = async () => {
			try {
				const data = (await getCategories()) || [];
			} catch {}
		};
		getData();
	}, []);
	return null;
};

export default SetCasinoCategories;
